export default {
    sidebarUrl: '/contextlol',
    sidebarVisible: false,
    searchQuery: '',
    lightboxVisible: false,
    lightboxMedia: {}
}